import { Entity } from '../index.js';
import { MaximumAgeInYearsOfRegistration, foundationCodeMapper, getOpenRegistryErrorsAndDetails, } from './denmark.js';
import { DebtRegistrationState, RegistryType, } from './index.js';
// Re-export the generic Danish debt-registration engine so consumers importing the
// `rki` module (e.g. the `debtRegisterCommon` namespace) get the shared rules too.
export * from './denmark.js';
// RKI-specific: a case already registered in the CLOSED registry can be moved to OPEN
// once a valid foundation document exists.
export const canMoveToOpen = (debtRegistrations, document) => {
    const isRegisteredInClosed = debtRegistrations.some((reg) => reg.state === DebtRegistrationState.ACTIVE &&
        reg.registryType === RegistryType.CLOSED);
    const open = getOpenRegistryErrorsAndDetails([document], undefined, {
        foundationCodeMapper,
        maxAgeYears: MaximumAgeInYearsOfRegistration.OPEN,
    });
    if (document.entityType === Entity.Case &&
        isRegisteredInClosed &&
        open.errors.length === 0) {
        return true;
    }
    return false;
};
//# sourceMappingURL=rki.js.map